import React from "react";
import {
  Breadcrumb,
  Steps,
  Table,
  Tooltip,
  Space,
  Divider
} from "antd";
import { Link, useLocation } from "react-router-dom";

import "../../../styles/Main.scss";

const SHIPMENT = {
  raId: "RA-2025-003",
  carrier: "BlueDart Logistics",
  tracking: "BD-9982110",
  status: "In Transit",
  estDelivery: "30-Dec-2025",
  steps: [
    {
      title: "Shipped",
      description: (
        <span>
          Central Warehouse<br />
          24-Dec, 10:00 AM
        </span>
      ),
      status: "finish",
    },
    {
      title: "In Transit",
      description: (
        <span>
          Regional Hub<br />
          25-Dec, 08:30 PM
        </span>
      ),
      status: "process",
    },
    {
      title: "Out for Delivery",
      description: "Pending",
      status: "wait",
    },
    {
      title: "Delivered",
      description: "Gamma Cement, Pending",
      status: "wait",
    },
  ],
  events: [
    {
      key: "1",
      datetime: "25-Dec 20:30",
      location: "Ahmedabad Hub",
      activity: "Arrived at Sorting Facility",
    },
    {
      key: "2",
      datetime: "24-Dec 18:00",
      location: "Central Warehouse",
      activity: "Picked up by Carrier",
    },
  ],
};

const eventColumns = [
  { title: "Date/Time", dataIndex: "datetime", key: "datetime", width: 160 },
  { title: "Location", dataIndex: "location", key: "location", width: 200 },
  { title: "Activity", dataIndex: "activity", key: "activity" },
];

const TrackShipment = () => {
  const location = useLocation();
  const data = location.state || SHIPMENT;

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <Tooltip title="Shipment tracking for return authorization">
              <h3>Shipment Tracking – {data.raId || SHIPMENT.raId}</h3>
            </Tooltip>
            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">Home</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/return-requests-list">Return Request Dashboard</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Shipment Tracking</Breadcrumb.Item>
            </Breadcrumb>
          </div>
         
        </div>
      </div>
      <section className="grid-sec FormSection Container aidocintak">
        <div className="FormBody">
          <div className="stepscontentwrap" style={{ padding: 0 }}>
            <div className="stepsContent" style={{ paddingRight: '5px' }}>
              <div
                className="formwrapper"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                }}
              >
                

          <div className="po-header-details">
                  <div className="po-row">
                    <strong>Carrier:</strong>
                     <span>{data.carrier || SHIPMENT.carrier}</span>
                  </div>

                  <div className="po-row">
                    <strong>Tracking # :</strong>
                    <span>{data.tracking || SHIPMENT.tracking}</span>
                  </div>

                  <div className="po-row">
                    <strong>Status :</strong>
                    <span> {data.status || SHIPMENT.status}</span>
                  </div>
                  <div className="po-row">
                    <strong>Est. Delivery :</strong>
                    <span>{data.estDelivery || SHIPMENT.estDelivery}</span>
                  </div>
                </div>

                  <Divider orientation="left" plain orientationMargin={0} style={{ marginBottom: 0 }}>
                  <div className="returninfo-title">Shipment Progress</div>
                </Divider>
                   
          <div className="shipStepWrap">
            <Steps
              current={1}
              items={(data.steps || SHIPMENT.steps).map((step) => ({
                title: step.title,
                description: step.description,
                status: step.status,
              }))}
            />
          </div>
          <Divider orientation="left" plain orientationMargin={0} style={{ marginBottom: 0 }}>
                  <div className="returninfo-title">Detailed Event Log</div>
                </Divider>
          
          <div className="tablewrp" style={{  marginTop: '10px', marginBottom: '16px' }}>
            <Table
              rowKey="key"
              columns={eventColumns}
              dataSource={data.events || SHIPMENT.events}
              pagination={false}
              size="small"
              scroll={{ x: 700 }}
            />
          </div>
                </div>
              </div>
            </div>
          </div>       
      </section>
  
    </>
  );
};

export default TrackShipment;

